<template>
  <div>
    <div class="Error">
      <div class="error_main">
        <img src="http://hten.isdg.cn/404.png"/>
      </div>
      <div class="error_footer">
        <span>{{num}}秒後自動的HPに飛び込む....</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
        num: 3,
      }
    },
    created(){
      this.time();
    },
    methods: {
      time(){
        let count = setInterval(() => {
          if (this.num > 0) {
            this.num--;
//            console.log(this.num);
          } else if (this.num == 0) {
            clearInterval(count);
            this.$router.push({path: "/"})
          }
        }, 1000)
      }
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .Error {
      width: 100%;
      height: 100%;
      background-color: #f6f7f9;
      .error_main {
        height: 234/$default-w+rem;
        width: 10rem;
        margin: 0 auto;
        margin-top: 100/$default-w+rem;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .error_footer {
        height: 30px;
        width: 100%;
        margin: 0 auto;
        margin-top: 50px;
        text-align: center;
        line-height: 30px;
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .Error {
      width: 100%;
      height: 100%;
      background-color: #f6f7f9;
      .error_main {
        height: 430px;
        width: 710px;
        margin: 0 auto;
        margin-top: 100px;
      }
      .error_footer {
        height: 30px;
        width: 100%;
        margin: 50px auto;
        text-align: center;
        line-height: 30px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/common/404.vue